// Copiado do Profit (ctsportal-frontend, src/theme/mui9/createAppTheme.js @ 79ed6b10) em 04/11/2026; os repos são separados.
import { createTheme, alpha } from "@mui/material/styles";
import buildClientColors, { SAFE_CLIENT_COLOR } from "../tokens";
import {
  dangerColor,
  successColor,
  warningColor,
  infoColor,
  grayColor,
  whiteColor,
  integrationColor,
} from "assets/jss/material-dashboard-pro-react.js";

// Tema do MUI v9 (novo). Reaproveita a MESMA fonte de cor do cliente que o tema
// v4 (theme/tokens.js), de modo que os dois motores de estilo fiquem coerentes
// durante a migracao por ondas. A cor "primary" e a cor do cliente/marca; as
// demais sao os tokens semanticos que ja existiam no JSS (danger/success/etc).
const createAppTheme = (
  implementationColor = SAFE_CLIENT_COLOR,
  implementationTextColor = undefined,
) => {
  const custom = buildClientColors({
    color: implementationColor,
    textColor: implementationTextColor,
  });

  let theme = createTheme({
    shape: { borderRadius: 3 },
    palette: {
      primary: {
        main: custom.clientColor,
        contrastText: custom.clientTextColor,
      },
      // Texto/icone branco sobre estas superficies coloridas (melhor leitura que
      // o preto que o MUI calcularia para amarelo/verde/ciano mais claros).
      error: { main: dangerColor[0], contrastText: whiteColor },
      success: { main: successColor[0], contrastText: whiteColor },
      warning: { main: warningColor[0], contrastText: whiteColor },
      info: { main: infoColor[0], contrastText: whiteColor },
      custom,
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: ({ ownerState, theme: t }) => {
            // Variantes "fantasma" (sem preenchimento): text e outlined. Nelas o
            // hover padrao do MUI e quase invisivel; damos um feedback um pouco
            // mais visivel. O contained ja tem hover proprio (cor solida).
            const isGhost =
              ownerState.variant === "text" ||
              ownerState.variant === "outlined";
            const paletteColor = t.palette[ownerState.color];
            return {
              textTransform: "lowercase",
              fontWeight: 500,
              letterSpacing: 0,
              borderRadius: 999,
              // Folga lateral extra (+5px) na variante text: o padding horizontal
              // padrao do MUI e pequeno e deixa o texto (e o fundo do hover)
              // colado nas bordas. iconOnly/xsmall definem o proprio padding via
              // sx (prioridade maior), entao nao sao afetados.
              ...(ownerState.variant === "text" && {
                paddingLeft: 12,
                paddingRight: 12,
              }),
              // "neutral" (acoes secundarias: Cancelar/Fechar) se apoia numa
              // escala de cinza (independe da cor da intencao).
              ...(isGhost &&
                ownerState.color === "neutral" && {
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.06)" },
                }),
              // Demais cores (primary/success/warning/info/error): hover baseado
              // na PROPRIA cor base da intencao, com alpha, para o mesmo nivel de
              // visibilidade do neutral sem "chapar" a cor.
              ...(isGhost &&
                ownerState.color !== "neutral" &&
                ownerState.color !== "inherit" &&
                paletteColor?.main && {
                  "&:hover": {
                    backgroundColor: alpha(paletteColor.main, 0.08),
                  },
                }),
              // Botoes com href viram <a>: o browser aplica a cor roxa de
              // ":visited". Fixamos a cor do texto (= cor da intencao nas
              // variantes fantasma) para nao aparecer roxo apos visitar o link.
              ...(isGhost &&
                paletteColor?.main && {
                  "&:visited": { color: paletteColor.main },
                }),
            };
          },
        },
      },
    },
  });

  // Cor semantica custom "neutral" (acao secundaria/discreta, ex.: "Cancelar").
  // Usa um cinza medio legivel: como `main` vira a COR DO TEXTO nas variantes
  // text/outlined, um cinza claro (ex.: #DDD) deixaria o texto quase invisivel.
  // Custom palette colors precisam ser aumentadas para ganhar light/dark/contrast.
  theme = createTheme(theme, {
    palette: {
      neutral: theme.palette.augmentColor({
        color: { main: grayColor[1], contrastText: whiteColor },
        name: "neutral",
      }),
      // Cor de marca das telas de login/integracao (vermelho escuro #790000).
      // Portada do token legado (integrationColor) para que os botoes dessas
      // telas migrem para o AppButton sem mudar de cor.
      integration: theme.palette.augmentColor({
        color: { main: integrationColor[0], contrastText: whiteColor },
        name: "integration",
      }),
    },
  });

  return theme;
};

export default createAppTheme;
